import { BaseService, PagedResponse } from "./base";

interface EscolaRequest {
  nome: string;
  anos: number[];
}

export interface EscolaSearchResponse {
  id: string;
  nome: string;
}

export interface EscolaResponse {
  nome: string;
  anos: number[];
}

class EscolasService extends BaseService {
  constructor() {
    super("escolas");
  }

  create(item: EscolaRequest): Promise<void> {
    return this.post("", item);
  }

  update(id: string, item: EscolaRequest): Promise<void> {
    return this.put(id, item);
  }

  search(): Promise<PagedResponse<EscolaSearchResponse>> {
    return this.get("");
  }

  read(id: string): Promise<EscolaResponse> {
    return this.get(id);
  }

  remove(id: string): Promise<void> {
    return this.delete(id);
  }
}

export default new EscolasService();
